import * as React from 'react';

import ProfileCreationSideFinishedApps from './ProfileCreationSideFinishedApps';
import ProfileCreationSideFinishedFaq from './ProfileCreationSideFinishedFaq';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./i18n/profile-creation-side-finished.i18n.json'));

type Props = {};

class ProfileCreationSideFinished extends React.PureComponent<Props> {
  render() {
    return (
      <section className="profile-creation-side-finished">
        <div className="profile-creation-side-finished__heading">
          {__t('profile_creation_side_finished.heading')}
        </div>
        <div className="profile-creation-side-finished__item">
          <ProfileCreationSideFinishedFaq />
        </div>
        <div className="profile-creation-side-finished__item">
          <ProfileCreationSideFinishedApps />
        </div>
        <div className="profile-creation-side-finished__item">
          <div className="profile-creation-side-finished__info">
            {__t('profile_creation_side_finished.email_info')}
            <a
              href={`mailto:${__t('profile_creation_side_finished.email')}`}
              className="profile-creation-side-finished__link"
            >
              {__t('profile_creation_side_finished.email')}
            </a>
          </div>
        </div>
      </section>
    );
  }
}

export default ProfileCreationSideFinished;
